import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcOutbreakControl = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M11.5 5.5c0 .843-.348 1.605-.908 2.15l2.187 3.827 3.826-2.187A3.003 3.003 0 0 1 19.5 5.5a3 3 0 1 1-2.15 5.092l-3.554 2.031 3.986 3.417a3 3 0 1 1-.977 1.139L12.47 13.46l-5.195 3.896a3 3 0 1 1-.9-1.2l5.146-3.86-2.23-3.902A3.004 3.004 0 0 1 5.5 5.5a3 3 0 0 1 6 0Zm-2 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-16 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M15.5 12.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcOutbreakControl");

export { IcOutbreakControl };
//# sourceMappingURL=ic-outbreak-control.js.map
